import {Store} from "./store";
import {who_get_css_device} from "./helpers";


export function leaflet_map(){

    /**
     *
     *
     *
    */

    Store();

    let map_nodes = document.querySelectorAll( '.who-leaflet-map' );
    let maps = Array.from( map_nodes );

    // console.log(map_nodes);

    let maps_store         = window.whodunit.theme.leaflet.maps         ;
    let markers_store      = window.whodunit.theme.leaflet.markers      ;
    let markers_data_store = window.whodunit.theme.leaflet.markers_data ;


    /**
     * Load the maps
     * - - - - - - - -
     * Main process
     *
     */

    maps.forEach(function ( map, index ) {

        let the_map = L.map( map, {  "tap": false, zoomControl: false, attributionControl : false } );
        L.control.zoom({ position: 'bottomright' }).addTo(the_map);

        let osm_layer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', { attribution : '' }).addTo( the_map );

        // setup
        the_map.touchZoom.disable();
        // the_map.scrollWheelZoom.disable();

        // main layer, handle markers & initial bounds
        let the_markers = JSON.parse( map.dataset.markers );
        let the_options = JSON.parse( map.dataset.options );

        let the_block = map.closest('.wp-block-who-leaflet-map') ;


        // save in store
        maps_store[ the_block.id ] = {
            'map'       : the_map ,
            'markers'   : the_markers,
            'options'   : the_options
        }

        //console.log(the_markers);

        // build the map
        map_loader( the_map, the_markers, the_options ) ;


        // Check if panel has already selection (ex : page refresh...)
        // verify uncheck checkbox

        let forms = the_block.querySelectorAll( 'form' ) ;
        forms = Array.from( forms );
        forms.forEach( function( form, index ){

            let filter = form.dataset.lslFilter ;
            let checkboxs = form.querySelectorAll( 'input[type="checkbox"]' ) ;
            checkboxs = Array.from( checkboxs );

            checkboxs.forEach( function( checkbox, index ){
                if( false === checkbox.checked ){

                    lsl_panel_toggle_marker_category( the_block.id , filter );
                    return false ;
                }
            });

        });


        // - - -

    });



    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -


    /**
     *  Helper : map builder
     *
     */

    function map_loader( the_map, the_markers, the_options ){

        let clustering             = the_options.clustering ;

        // http://leaflet.github.io/Leaflet.markercluster/
        let the_map_main_cluster   = L.markerClusterGroup({
	        showCoverageOnHover: false,
            iconCreateFunction: function(cluster) {
                return L.divIcon({ html: '<div class="leaflet-marker-icon-cluster">' + cluster.getChildCount() + '</div>' });
            },
        });

        let the_active_marker    = null ;
        let map_has_active_maker = false ;

        let the_map_initial_bounds = [] ;

        the_markers.forEach(function ( marker, index ){

            let the_marker_options = {} ;

            // Finalement on désactive la focntionnalité de mis en avant de l agence active :
            /*
            if( true === marker.marker_is_active  ){
                map_has_active_maker = true ;
                the_active_marker = marker ;
            }
            */

            // - -

            // custom icon
            if( false != marker.marker_category_icon ){

                the_marker_options.icon = get_custom_icon( marker.marker_category_icon , marker.marker_is_active, marker.marker_post_id ) ;
            }

            // init
            let the_LatLng = new L.LatLng( marker.marker_coords.lat, marker.marker_coords.lng ) ;
            let the_marker = L.marker( the_LatLng, the_marker_options );

            // collect
            markers_store[ marker.marker_post_id ] = the_marker ;
            markers_data_store[ marker.marker_post_id ] = marker ;

            // add
            if( clustering ){
                if( '' != marker.tooltip ){
                    the_map_main_cluster.addLayer( the_marker.bindPopup( marker.tooltip ).openPopup() );
                }else{
                    the_map_main_cluster.addLayer( the_marker );
                }

            }else{

                if( '' != marker.tooltip ){
                    the_map.addLayer( the_marker.bindPopup( marker.tooltip ).openPopup() );
                }else{
                    the_map.addLayer( the_marker );
                }

            }

            // hover :: scale up
            the_marker.on( 'mouseover', function(e){ reveal_the_marker( e.target._icon ) ; });

            // hover :: scale down
            the_marker.on( 'mouseout', function(e){ reset_the_marker( e.target._icon ) ; });

            // click
            the_marker.on( 'click', function(){ view_agency_card( this, the_map ); });

            the_map_initial_bounds.push( the_LatLng );

        });

        if( clustering ){
            the_map.addLayer( the_map_main_cluster );
        }

        // centre ttes les agences
        if( the_map_initial_bounds.length > 0 && false === map_has_active_maker ){
            the_map.fitBounds( the_map_initial_bounds, { padding : [50,50]} );
        }

        // centre sur l agence active
        if( true === map_has_active_maker && null != the_active_marker  ){

            // set view
            the_map.setView( new L.LatLng( the_active_marker.marker_coords.lat, the_active_marker.marker_coords.lng ), 8, { padding : [50,50]} );

            let current_map_marker = markers_store[ the_active_marker.marker_post_id ] ;

            // view card
            let device = who_get_css_device() ;
            if( device != 'mobile' ){ view_agency_card( current_map_marker , the_map ); }


            // reveal active marker
            reveal_active_marker( the_map ) ;

        }

    }



    /**
     *  Helper : map icon
     *
     */

    function get_custom_icon(marker_icon, marker_active = false, marker_post_id) {
        let marker_className = 'who-leaflet-map__marker-icon';
    
        // Add marker_post_id to the marker_className
        marker_className += ' ' + 'marker-post-id-' + marker_post_id;
    
        if (true === marker_active) {
            marker_className += ' ' + 'who-leaflet-map__marker-icon--is-active';
        }
    
        var the_custom_icon = L.Icon.extend({
            options: {
                iconUrl: marker_icon.url,
                iconSize: [marker_icon.width, marker_icon.height],
                iconAnchor: [marker_icon.width * 0.5, marker_icon.height],
                popupAnchor: [0, (-0.5 * marker_icon.height)],
                className: marker_className,
                shadowUrl: '',
                shadowSize: [0, 0],
                shadowAnchor: [0, 0]
            }
        });
    
        return new the_custom_icon();
    }
    



    /**
     *  Helper : view_agency_card()
     *
     */

    function view_agency_card( the_marker , the_map ){


        // find the marker & load template in panel

        let post_id = 0 ;
        let the_block = the_map._container.closest('.wp-block-who-leaflet-map') ;

        Object.entries(markers_store).forEach( ([key, value] ) => {
            if( value === the_marker ){ post_id = key ; return ; }
        });


        if( 0 === post_id ){ return ; }

        Object.entries(markers_data_store).forEach( ([key, data ] ) => {

            if( parseInt( key ) === parseInt( post_id ) ){

                clean_block_panel( the_block );

                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/template

                const template = document.querySelector( '#' + data.card );
                const clone = template.content.cloneNode(true );

                const panel_card_wrapper = the_block.querySelector(".wp-block-who-leaflet-map__card-wrapper");
                panel_card_wrapper.appendChild(clone);

                // bind
                let btn_return = panel_card_wrapper.querySelector('.wp-block-who-leaflet-map__card__return') ;

                btn_return.addEventListener( 'click', function( e ){

                    e.preventDefault();
                    e.stopPropagation();

                    let the_block = e.currentTarget.closest( '.wp-block-who-leaflet-map' );
                    close_block_panel( the_block );
                });



                // run

                set_current_block_clicked_marker( the_map._container.id, the_marker._icon, the_marker ) ;

                open_block_panel( the_block );

                setTimeout(function(){ reveal_the_marker( the_marker._icon ); }, 450 );

                return;
            }
        });


    }


    function set_current_block_clicked_marker( block_id, html_element, map_marker ){

        maps_store[ block_id ].clicked_marker = {} ;

        maps_store[ block_id ].clicked_marker.html_element = html_element ;
        maps_store[ block_id ].clicked_marker.map_marker = map_marker ;
    }



    /**
     *  Helpers :
     *
     */

    // marker

    function reveal_the_marker( the_marker_node ){

        the_marker_node.classList.add('who-leaflet-map__marker-icon--current');

        let transform = the_marker_node.style.transform
        transform = transform.replace( "scale(1)", "" );
        transform = transform.replace( "scale(1.4)", "" );
        the_marker_node.style.transform = transform + ' ' + 'scale(1.4)' ;
        console.log(the_marker_node.style);
    }

    function reset_the_marker( the_marker_node ){

        the_marker_node.classList.remove('who-leaflet-map__marker-icon--current');

        let transform = the_marker_node.style.transform
        transform = transform.replace( "scale(1)", "" );
        transform = transform.replace( "scale(1.4)", "" );
        the_marker_node.style.transform = transform + ' ' + 'scale(1)' ;
    }

    function reveal_active_marker( the_map ){

        let the_block    = the_map._container.closest('.wp-block-who-leaflet-map') ;
        let active_marker = the_block.querySelector('.who-leaflet-map__marker-icon--is-active') ;

        reveal_the_marker( active_marker );
    }


    // Panel

    function open_block_panel( the_block ){

        show_overlay( the_block ) ;

        const panel = the_block.querySelector( '.wp-block-who-leaflet-map__panel' ) ;
        panel.classList.remove('wp-block-who-leaflet-map__panel--close') ;
        map_layout( the_block, panel.offsetWidth );
    }

    function close_block_panel( the_block ){

        hide_overlay( the_block );

        const panel = the_block.querySelector( '.wp-block-who-leaflet-map__panel' ) ;
        panel.classList.add('wp-block-who-leaflet-map__panel--close') ;

        // reset_the_marker( ... ); ?
        // pas besoin car avec le refresh de la map, le scale disparait

        map_layout( the_block, 0 );
    }

    function clean_block_panel( the_block ){

        const card_wrapper = the_block.querySelector(".wp-block-who-leaflet-map__card-wrapper");
        card_wrapper.innerHTML = "";
    }


    // Overlay

    function show_overlay( the_block ){
        const map_overlay = the_block.querySelector(".wp-block-who-leaflet-map__overlay");
        map_overlay.classList.remove('wp-block-who-leaflet-map__overlay--hidden');
    }

    function hide_overlay( the_block ){
        const map_overlay = the_block.querySelector(".wp-block-who-leaflet-map__overlay");
        map_overlay.classList.add('wp-block-who-leaflet-map__overlay--hidden');
    }


    // map
    function map_layout( the_block, margin_left = 0 ){


        // changement de layout seulement si la carte fait un minimum de large
        // sinon on laisse le panneau en overlay et voila.
        if( the_block.offsetWidth < 460 ){
            margin_left = 0 ;
        }

        const leaflet_map = the_block.querySelector( '.who-leaflet-map' ) ;
        leaflet_map.style.width = 'calc( 100% - ' + margin_left + 'px )' ;

        let map_zoom = 14 ;
        if( margin_left > 0 ){ map_zoom = 18 ; }

        let store = maps_store[ the_block.id ] ;

        let the_map = store.map ;
        let the_map_marker = store.clicked_marker.map_marker ;

        the_map.invalidateSize();
        the_map.setView( the_map_marker._latlng, map_zoom, { padding : [50,50]} );
    }







    /**
     *  Binds
     *  - - - - - - -
     *  — overlay
     *
     */

    Object.keys( maps_store ).forEach(function ( item ) {

        let block_id  = item ;
        let values    = maps_store[ item ] ;

        // check if overlay
        var overlay = document.querySelector( '#' + block_id + ' ' + '.wp-block-who-leaflet-map__overlay' );

        // has panel > bind event
        if( overlay != null ){

            let the_block = overlay.closest( '.wp-block-who-leaflet-map' );

            // handle click on overlay
            overlay.addEventListener( 'click', function( e ){

                e.preventDefault();
                e.stopPropagation();

                close_block_panel( the_block );
            });
        }

    });




    // - - - -

}